/**
 * Remove any duplicate objects from an array of objects
 * https://betterprogramming.pub/how-to-find-unique-objects-in-an-array-in-javascript-by-object-reference-or-key-value-pairs-131338898d7a
 * Warning: if the element is large this could be costly to performance
 * @param {*} array an array of objects
 * @returns an array of unique objects
 */
export const removeDuplicateObjects = (array) =>
    [...new Set(array.map((element) => JSON.stringify(element)))].map((string) => JSON.parse(string));

export const getUniqueArray = (array) => [...new Set(array)];
